import { render, staticRenderFns } from "./AssignTechModal.vue?vue&type=template&id=64d3b575&scoped=true&lang=pug"
import script from "./AssignTechModal.vue?vue&type=script&lang=js"
export * from "./AssignTechModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d3b575",
  null
  
)

export default component.exports